import { phonePresentation } from '../../services/phonePresentation';

export function assignedUserPhone(user) {
    if (!user || user.former_member)
        return '';

    const candidates = [user.phone, user.mobile_phone, user.pro_phone, user.fix_phone];
    for (const candidate of candidates) {
        const phone = String(candidate ?? '').trim();
        if (phone)
            return phone;
    }

    return '';
}

export function assignedPhonePresentation(user) {
    const raw = assignedUserPhone(user);
    if (!raw)
        return null;

    return phonePresentation(raw);
}
